// The view an Email activity request asks rapid-api-content for (its
// `scope` parameter): the staff Internal tools page's every organization,
// or the organization's own page -- the caller's organization only, super
// admins included (owner direction 2026-10-07). The server enforces it.
export const scopeOf = system => (system ? 'system' : 'organization')
